import { Box, Typography } from "@mui/material"
import { WarningOutlined } from "@mui/icons-material"
import { capitalizeFormMessage } from "../helpers/form-message"

import "./style.scss"

interface WarningProps {
  warning: string | null
}

export default function Warning({ warning }: WarningProps) {
  if (!warning) {
    return null
  }

  return (
    <Box className="components_optimize-warning">
      <Box className="warning-content">
        <WarningOutlined className="warning-icon" />
        <Typography className="warning-message">
          {capitalizeFormMessage(warning)}
        </Typography>
      </Box>
    </Box>
  )
}
